import { NavLink } from 'react-router-dom';
import { MailQuestion, HandshakeIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/join-requests', label: 'Solicitudes', icon: MailQuestion },
  { to: '/onboarding-requests', label: 'Acceso ASI', icon: HandshakeIcon },
];

export function SolicitudesTabs() {
  return (
    <nav className="flex items-center gap-1 border-b border-border mb-4">
      {TABS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end
          className={({ isActive }: { isActive: boolean }) =>
            cn(
              'flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px',
              isActive
                ? 'border-amber-500 text-amber-500'
                : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
            )
          }
        >
          <Icon className="h-4 w-4" />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
